import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import CustomerMainLayout from '../../CustomerComponents/CustomerMainLayout';

const ProductFormRedirect = () => {
    const [formTypeCheckLoader, setFormTypeCheckLoader] = useState(true);

    useEffect(() => {
        routeToMainFormForNonAIPackage();
    }, []);

    const routeToMainFormForNonAIPackage = () => {
        let currentSubscriptionPlan = null;
        let plan_payload = {
            "data": "subscription-plan",
            "username": localStorage.getItem('username'),
        };

        axios.post(ENVIRONMENT.GET_UPDATE_SUBSCRIPTION_DATA, plan_payload)
            .then(res => {
                if (res.data['is_active']) {
                    currentSubscriptionPlan = res.data['name'];
                    if (currentSubscriptionPlan === 'enterprise' || currentSubscriptionPlan === 'custom_contract') {
                        window.location.href = window.location.href.replace('create-ai-product', 'create-existing-physical-product');
                    } else {
                        window.location.href = window.location.href.replace('create-ai-product', 'ai-asset-creator');
                    }
                } else {
                    window.location.href = window.location.href.replace('create-ai-product', 'ai-asset-creator');
                }
            });
    };

    return (
        <CustomerMainLayout selected='3'>
        
            <div className="add-product-layout-container">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '240px' }}>
                    {formTypeCheckLoader && <LoadingOutlined style={{ fontSize: '48px' }} />}
                </div>
            </div>
        </CustomerMainLayout>
    );
};

export default ProductFormRedirect;
